import React, { useState, useEffect } from "react";
import axiosAPI from "../api/axiosApi";
import * as RB from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.css';
import './InvestigationPage.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

// TODO: Разобраться с CVS-экспортом.
// import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// const { ExportCSVButton } = CSVExport;

const columns = [
    {
        dataField: 'root_disk_serial',
        text: 'Серийный номер диска',
        sort: true,
        // formatter: (cell, row) => types[cell]
    },
    {
        dataField: 'first_seen',
        text: 'Впервые'
    },
    {
        dataField: 'last_seen',
        text: 'Последний раз',
        sort: true
    },
    {
        dataField: 'latest_detail.department__name',
        text: 'В.ч',
        sort: true
    },
    {
        dataField: 'latest_detail.department',
        text: 'Код В.ч',
    },
    {
        dataField: 'latest_detail.ipv4_address',
        text: 'IP',
        sort: true
    },
    {
        dataField: 'latest_detail.user_domain',
        text: 'Домен',
        sort: true
    },
    {
        dataField: 'latest_detail.user_name',
        text: 'Пользователь',
        sort: true
    },
    {
        dataField: 'check_date',
        text: 'Дата проверки',
        type: 'date'
    }
];


const columns_detail = [
    {
        dataField: 'dt',
        text: 'Дата',
        type: 'date'
    },
    {
        dataField: 'ipv4_address',
        text: 'IP',
        sort: true
    },
    {
        dataField: 'user_domain',
        text: 'Домен',
        sort: true
    },
    {
        dataField: 'user_name',
        text: 'Пользователь',
        sort: true
    },
    {
        dataField: 'department__name',
        text: 'В.ч',
        sort: true
    },
    {
        dataField: 'department',
        text: 'Код В.ч',
    }
];



const defaultSorted = [{
    dataField: 'root_disk_serial',
    order: 'desc'
}];
  
import Header from '../common/Header'

export const MonitoringPCPage = () => {
    const [sd_pc_to_monitor_set, setPCtoMonitorSet] = useState([{key: 0}]);

    const expandRow = {
        // eslint-disable-next-line react/display-name
        renderer: row => (
          <>
            <RB.Container fluid>
                <RB.Row>
                    <RB.Col sm={6}>
            <RB.Button onClick={() => {onIgnore(row, 'now');}}>Игнорировать временно</RB.Button>
                    </RB.Col>
                    <RB.Col sm={6}>
            <RB.Button onClick={() => {onIgnore(row, 'forever');}}>Забыть навсегда</RB.Button>
                {/* {row.root_disk_serial} */}
                </RB.Col>
                </RB.Row>
            </RB.Container>
                <BootstrapTable keyField='dt' 
                                data={row.details} 
                                columns={columns_detail} 
                                rowStyle={{ fontSize: '90%' }} 
                                pagination={ paginationFactory() }
                />
    
    
          </>
        ),
        showExpandColumn: true,
        onlyOneExpanding: true,    
      };
    
      const onIgnore = (row, how_to_ignore) => {
        console.log('onIgnoreForever');
    
        // debugger;    
        var old_table = sd_pc_to_monitor_set;
        var new_table = old_table.filter(function(value, index, arr){ 
            return value.root_disk_serial != row.root_disk_serial;
        });
        setPCtoMonitorSet(new_table);

        const uploadData = new FormData();
        uploadData.append('root_disk_serial', row.root_disk_serial);
        uploadData.append('how_to_ignore', how_to_ignore);
    
        axiosAPI.post("ignore4now/", uploadData)
        .then(function (res) {
            row.check_date = new Date();
            console.log('OK!');
        })
        .catch(function (error) {
            console.log(error);
        })
    };

    const fetchData = (itype) => {
        axiosAPI.defaults.timeout = 30000;
        axiosAPI.get("get-pc-monitoring/")
            .then(function (res) {
                setPCtoMonitorSet(res.data);
                console.log(res.data);
                // var row_count_set_ = JSON.parse(JSON.stringify(row_count_set));
                // var mark_count_set_ = JSON.parse(JSON.stringify(mark_count_set));
                // var pc_count_set_ = JSON.parse(JSON.stringify(pc_count_set));
                // var department_count_set_ = JSON.parse(JSON.stringify(department_count_set));
                // for (var row in res.data){
                //     var r_ = res.data[row];
                //     var dt_ = r_.dt;
                //     row_count_set_.labels.push(dt_);
                //     mark_count_set_.labels.push(dt_);
                //     pc_count_set_.labels.push(dt_);
                //     department_count_set_.labels.push(dt_);

                //     row_count_set_.datasets[0].data.push(r_.row_count);
                //     mark_count_set_.datasets[0].data.push(r_.mark_count);
                //     pc_count_set_.datasets[0].data.push(r_.pc_count);
                //     department_count_set_.datasets[0].data.push(r_.department_count);
                // }   
            })
            .catch(function (error) {
                console.log(error);
                // return "";
            })
    };

    useEffect(() => {
        fetchData();
    }, []);    

    return (
        <>
        <Header />
        <RB.Container fluid>
            <RB.Row>
                <RB.Col sm={12}>
                    <BootstrapTable 
                            keyField='root_disk_serial' 
                            data={sd_pc_to_monitor_set} 
                            columns={columns} 
                            rowStyle={{ fontSize: '90%' }} 
                            pagination={ paginationFactory() }
                            expandRow={ expandRow }
                            defaultSorted={ defaultSorted }
                            bootstrap4
                            striped
                            hover
                            condensed                            
                            />
                </RB.Col>
            </RB.Row>
        </RB.Container >
        </>
    );
};
